/*************  Radera ena lang  /*************/

$(function () {
  if ($("#userform #preferredLanguage-field").length == 2) {
    $("#userform #preferredLanguage-field").last().remove();
  } 
});


/*************  add red border to section if visibility field is set to other the default  /*************/


$(function () {
  if ($("form .matrixblock").length) {
    var refreshIntervalId = setInterval(function(){ 
      var specialVisibility = ["Visa enbart på USA-sajten","Dölj på USA-sajten","Visa enbart på svenska sajten"];

      // Craft 5: fälten ligger direkt i blocket (Spoons .spoon-fields finns inte längre)
      $('form .matrixblock .selectize>select').each(function () {
        //alert('|' + $(this).text().trim() + '|');
        if ($.inArray( $(this).text().trim(), specialVisibility) >= 0) {
          //alert($(this).text());

          $(this).parents(".matrixblock").addClass("specialVisibility");

        } else if ($(this).text() == "Visa på alla sajter") {
          $(this).parents(".matrixblock").removeClass("specialVisibility");
        }
      });
      //clearInterval(refreshIntervalId);
    }, 1000);
    
  }
    
});



/*************  if show english version for other languages is set, then show indicator for that  /*************/


$(function () {
  //loop all options in forceLang field that are selected

  $('form #fields-forceLang').find(":selected").each(function () {   
    if(($(this).text() == "Swedish" && $("body").hasClass("site--sv")) || ($(this).text() == "English (United States)" && $("body").hasClass("site--us"))) {
      //insert text before #main-content
      $("#main-content").before("<div style='color:red;padding-left:24px;font-size:18px;font-weight:600;'>OBS: Under fliken Övrigt är det inställt att den engelska internationella versionen ska visas för besökare.</div>");
    }
    
  });

  
    
});